var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AddCreditCardMethodLayout',{attrs:{"isLoading":_vm.isLoading},on:{"onCancel":_vm.hideModal,"onSaveCard":_vm.saveCard}})}
var staticRenderFns = []

export { render, staticRenderFns }